import React from "react"

const Divider = () => {
  return <div className="h-px bg-ui-medium w-full my-12" />
}

export default Divider
